import { Box } from '@chakra-ui/react';
import {
    AriaPopoverProps,
    DismissButton,
    Overlay,
    usePopover,
} from '@react-aria/overlays';
import { FC, ReactElement, useRef } from 'react';
import { OverlayTriggerState } from 'react-stately';

type PopoverProps = Omit<AriaPopoverProps, 'popoverRef'> & {
    children: ReactElement;
    state: OverlayTriggerState;
};

export const Popover: FC<PopoverProps> = (props) => {
    const ref = useRef(null);
    const { state, children } = props;

    const { popoverProps, underlayProps } = usePopover(
        {
            ...props,
            popoverRef: ref,
        },
        state
    );

    return (
        <Overlay>
            <div {...underlayProps} style={{ display: 'fixed', inset: 0 }} />
            <Box
                {...popoverProps}
                ref={ref}
                background="white"
                border="1px solid"
                borderColor="gray.300"
                borderRadius="md"
                position="absolute"
                zIndex="10"
                boxShadow="lg"
                marginTop="1"
                py={2}
                px={6}
                outline="none"
                overflow="auto"
                minH={80}
            >
                {/**
                 * Add a hidden <DismissButton> component at the end of the popover
                 * to allow screen reader users to dismiss the popup easily.
                 * Ref: https://react-spectrum.adobe.com/react-aria/usePopover.html#example
                 */}
                <DismissButton onDismiss={state.close} />
                {children}
                <DismissButton onDismiss={state.close} />
            </Box>
        </Overlay>
    );
};
